import { InputSearchPro } from 'components/InputSearch';
import { empresaToString } from 'utils/padronesToString';
import BusquedaAvanzadaPadrones from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';
import { padronesEnum } from '../enums';

const fieldsInfo = {};

const tabs = [
  {
    title: null,
    fields: [
      'clave_de_anexo',
      'clave_de_cuenta',
      'fecha_de_inicio_de_servicio',
      'tipo_de_servicio',
      'empresa',
      'tipo_de_contrato',
    ],
  },
];

const configs = {
  clave_de_anexo: {
    formItemProps: {
      label: 'Clave de anexo',
      required: true,
    },
  },
  clave_de_cuenta: {
    formItemProps: {
      label: 'Clave de Cuenta',
      required: true,
    },
  },
  fecha_de_inicio_de_servicio: {
    formItemProps: {
      label: 'Fecha de inicio de servicio',
      required: true,
    },
  },
  tipo_de_servicio: {
    formItemProps: {
      label: 'Tipo de servicio',
      required: true,
    },
  },
  empresa: {
    advanced: true,
    control: InputSearchPro,
    advancedComponent: BusquedaAvanzadaPadrones,
    advancedComponentProps: { tipoDePadron: padronesEnum.EMPRESA, allowAdd: false },
    advancedComponentName: 'BusquedaAvanzadaPadrones',
    label: 'Empresa',
    tooltip: 'Búsqueda por Razón social',
    resultProps: {
      name: 'empresa',
      label: 'Empresa',
      render: (empresa) => empresaToString(empresa),
    },
  },
  tipo_de_contrato: {
    formItemProps: {
      label: 'Tipo de contrato',
      required: true,
    },
  },
};

const forbiddenProps = [];

export default {
  configs,
  forbiddenProps,
  fieldsInfo,
  tabs,
};
